import { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import HttpAxios from '../../commons/hooks/http';
import { useUserMe } from '../../commons/hooks/userme';
import { AppContext } from '../../commons/context/App-context';
import { QuestionsContext } from '../../commons/context/Questions';
import Header from '../../commons/components/header/Header';
import Menu from '../../commons/components/menu/Menu';
import Modal from '../../commons/components/modal/Modal';
import { EErrorMsg } from '../../commons/statics/controls';
import IconArrowLeft from '../../images/arrow-left.svg';
import IconArrowRight from '../../images/arrow-right.svg';
import { IUserMe } from '../../commons/interfaces/user';
import { TMenuActions } from '../../commons/interfaces/items';
import ActionsApply from '../../commons/components/actions-apply/Actions-apply';
import Wizard from '../../commons/components/wizard/Wizard';
import { useQuestionsMe } from '../../commons/hooks/questionsme';
import enviroment from '../../enviroments/enviroment';
import './dashboard.scss';

function Dashboard() {
    const history = useHistory();
    const [start] = useState<boolean>(false);
    const { changeIsLoading } = useContext(AppContext);
    const {
        selectedMenu,
        changeSelectedMenu,
        progressQuestions,
        changeProgressQuestions,
        changeCanApply,
    } = useContext(QuestionsContext);
    const [msgError, setMsgError] = useState<string>('');
    const [name, setName] = useState<string>(' ');
    const [userMe, setUserMe] = useUserMe();
    const [listMenu, setListMenu] = useState<Array<any>>([]);
    const [questions, setQuestions] = useState<Array<any>>([]);
    const [initLoading, setInitLoading] = useState<boolean>(true);
    const [questionsMe, setQuestionsMe] = useQuestionsMe();

    const getUserMe = (cb: Function) => {
        setInitLoading(true);
        changeIsLoading(true);
        setMsgError('');
        HttpAxios.get('/user/me')
            .then((res: any) => {
                const { err, response, status } = res?.data || {};
                if (err) {
                    setInitLoading(false);
                    changeIsLoading(false);
                    setMsgError(err);
                    if (!status) {
                        setUserMe.reset();
                        history.push('/signin');
                    }
                } else {
                    const token = userMe?.token || '';
                    const {
                        nombre = '',
                        avancepostulacion = 0,
                        postulacionenviada,
                        total_preguntas = 0,
                        total_respondidas = 0,
                        administrador,
                        flagpostulacionanterior,
                        flagdatosactualizados,
                    } = response;

                    if (flagpostulacionanterior && !flagdatosactualizados) {
                        response.token = token;
                        setUserMe({
                            ...response,
                        });
                        setInitLoading(false);
                        changeIsLoading(false);
                        history.push('/update-register');
                    } else {
                        if (postulacionenviada && !administrador) {
                            response.token = token;

                            setUserMe({
                                ...response,
                            });
                            setInitLoading(false);
                            changeIsLoading(false);
                            history.push('/thanks');
                        } else {
                            setName(nombre);
                            changeProgressQuestions(avancepostulacion);
                            changeCanApply(
                                avancepostulacion >= enviroment.limitApply
                            );
                            response.token = token;

                            setUserMe({
                                ...response,
                            });
                            setQuestionsMe({
                                avancepostulacion,
                                total_preguntas,
                                total_respondidas,
                            });
                            setMsgError('');
                            cb(response);
                        }
                    }
                }
            })
            .catch(() => {
                setInitLoading(false);
                changeIsLoading(false);
                setMsgError(EErrorMsg.generic);
            });
    };

    const setDashboad = (response: any) => {
        const { administrador } = response as IUserMe;

        if (administrador) {
            setInitLoading(false);
            changeIsLoading(false);
            history.push('/search');
        } else {
            getQuestions();
        }
    };

    const processQuestions = (q: Array<any>) => {
        setQuestions(q);
        const _menu: Array<any> = q.map((item: any) => ({
            label: item.descripcion || '',
            value: item.idcategoria || '',
        }));
        setListMenu(_menu);
    };

    const getQuestions = () => {
        HttpAxios.get('/forms/questions/me')
            .then((res: any) => {
                const { err } = res?.data || {};
                setInitLoading(false);
                changeIsLoading(false);
                if (err) {
                    setMsgError(err);
                } else {
                    processQuestions(res.data || []);
                    setMsgError('');
                }
            })
            .catch(() => {
                setInitLoading(false);
                changeIsLoading(false);
                setMsgError(EErrorMsg.generic);
            });
    };

    const controlMenu = (type: TMenuActions) => {
        const item = Number(selectedMenu?.value) - 1;

        if (type === 'prev') {
            changeSelectedMenu(item > 0 ? listMenu[item - 1] : listMenu[0]);
        } else if (type === 'next') {
            changeSelectedMenu(
                item < listMenu.length
                    ? listMenu[item + 1]
                    : listMenu[listMenu.length]
            );
        }
    };

    useEffect(() => {
        getUserMe(setDashboad);
    }, [start]);

    return (
        <>
            <div className="ContentFull">
                <Header
                    initLoading={initLoading || !!msgError}
                    title={
                        'Llena este formulario y postula a la Lista de Empresas que Transforman el Perú'
                    }
                    name={name}
                    progress={progressQuestions}
                ></Header>
                <div className="Content">
                    {initLoading || msgError ? (
                        <div className="ContentQuestions">
                            <div className="helpText invalid">{msgError}</div>
                        </div>
                    ) : (
                        <>
                            <Menu items={listMenu}></Menu>
                            <div className="ContentQuestions">
                                {questions?.length > 0 && (
                                    <Wizard questions={questions}></Wizard>
                                )}
                            </div>

                            <div className="ContentNav">
                                {Number(selectedMenu?.value) > 1 && (
                                    <button
                                        className="button buttonLink"
                                        type="button"
                                        onClick={() => controlMenu('prev')}
                                    >
                                        <img
                                            src={IconArrowLeft}
                                            className="buttonIconLeft"
                                            alt=""
                                        />
                                        Sección Anterior
                                    </button>
                                )}
                                <span className="separate"></span>
                                <ActionsApply isInline={true}></ActionsApply>
                                <span className="separate"></span>
                                {listMenu?.length > 0 &&
                                    Number(selectedMenu?.value) <
                                        listMenu?.length && (
                                        <button
                                            className="button buttonLink"
                                            type="button"
                                            onClick={() => controlMenu('next')}
                                        >
                                            Siguiente sección
                                            <img
                                                src={IconArrowRight}
                                                className="buttonIconRight"
                                                alt=""
                                            />
                                        </button>
                                    )}
                            </div>

                            <div className="ContentActionsMobile">
                                <ActionsApply></ActionsApply>
                            </div>
                        </>
                    )}
                </div>
            </div>
            <Modal
                title="¡Recuerda!"
                text="Una vez enviado la postulación ya no se puede modificar y no se puede volver a
enviar la postulación"
            ></Modal>
        </>
    );
}

export default Dashboard;
